import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import styles from './CookieConsent.module.css'
const COOKIE_STORAGE_KEY = 'medistime_cookie_consent';

export default function CookieConsent({ onConsent }) {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (!consent) setShowBanner(true);
    else onConsent(JSON.parse(consent));
  }, []);

  const handleAcceptAll = () => {
    const consent = { required: true, optional: true };
    localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(consent));
    onConsent(consent);
    setShowBanner(false);
  };

  const handleAcceptRequiredOnly = () => {
    const consent = { required: true, optional: false };
    localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(consent));
    onConsent(consent);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={styles.banner}>
      <p className={styles.consentText}>
        {t("cookieConsent.text")} 
        <p>
         {t('readMore')}{' '}
         <Link to="/privacy-policy">{t('privacyLink')}</Link>.
        </p>


      </p>
      <div className={styles.buttonGroup}>
      <button onClick={handleAcceptAll} className={styles.buttonPrimary}>{t("cookieConsent.accept")}</button>
      <button onClick={handleAcceptRequiredOnly} className={styles.buttonSecondary}>{t("cookieConsent.acceptEssential")}</button>
      </div>
      </div>
  );
}


